<template>
  <p-info @btn-update="handleUpdate" />
</template>
<script>
import pInfo from "../productInfo";
export default {
  components: { pInfo },
  mounted() {
    this.handleUpdate();
  },
  methods: {
    handleUpdate() {
      //处理个性化样式
      this.$nextTick(x => {
        let dom = document.querySelector("span[class~='btn-productinfo']");
        if (dom) {
          dom.classList.add("btn-init-productinfo-br");
        }
      });
    }
  }
};
</script>

<style lang="scss">
.btn-init-productinfo-br {
  display: block;
  height: 1.125rem;
  width: 100%;
  font-size: 0.375rem;
  line-height: 1.125rem;
  color: #323233;
  text-align: center;
  background: #ffe600;
  border-radius: 4px;
}
</style>
